import { render, staticRenderFns } from "./BaseLocationViewModal.vue?vue&type=template&id=8628a3c8&scoped=true&"
import script from "./BaseLocationViewModal.vue?vue&type=script&lang=js&"
export * from "./BaseLocationViewModal.vue?vue&type=script&lang=js&"
import style0 from "./BaseLocationViewModal.vue?vue&type=style&index=0&id=8628a3c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8628a3c8",
  null
  
)

export default component.exports